import { Delete, Edit } from '@mui/icons-material';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';

import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';

interface Props {
  handleEdit: (e) => void;
  handleDelete: (e) => void;
}

/**
 * Default MenuItems including Edit and Delete action
 * @param handleEdit
 * @param handleDelete
 * @returns MenuItems in a React Fragment
 */
export const MenuActions = ({ handleEdit, handleDelete }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <MenuItem onClick={handleEdit}>
        <ListItemIcon>
          <Edit sx={{ color: 'lightblue' }} />
        </ListItemIcon>
        <ListItemText>{t(translations.common.edit())}</ListItemText>
      </MenuItem>

      <MenuItem onClick={handleDelete}>
        <ListItemIcon>
          <Delete sx={{ color: 'red' }} />
        </ListItemIcon>
        <ListItemText>{t(translations.common.delete())}</ListItemText>
      </MenuItem>
    </>
  );
};
